<div class="error-msg" *ngIf="control.errors && (control.touched || control.dirty)">
  <img src="./assets/images/icons/icon-error.png" />
  <span *ngIf="control.errors.required">
      Proszę wypełnić to pole
  </span>
  <span *ngIf="control.errors.pattern">
      Proszę wpisać poprawną wartość
  </span>
</div>
